import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "16",
  fill: "none",
  viewBox: "0 0 17 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M3.5 2.5a2.5 2.5 0 0 1 5 0 2.5 2.5 0 0 1 5 0v.006c0 .07 0 .27-.038.494H15.5a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5A1.5 1.5 0 0 1 14 16H3a1.5 1.5 0 0 1-1.5-1.5V7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h2.038a3 3 0 0 1-.038-.494zm1.068.5H7.5v-.5a1.5 1.5 0 1 0-3 0c0 .085.002.274.045.43q.011.043.023.07M9.5 3h2.932a1 1 0 0 0 .023-.07c.043-.156.045-.345.045-.43a1.5 1.5 0 0 0-3 0zm-8 1v2h6V4zm8 0v2h6V4zm5 3h-5v8H14a.5.5 0 0 0 .5-.5zm-7 8V7h-5v7.5a.5.5 0 0 0 .5.5z"
    }, null, -1)
  ]))]))
}
export default { render: render }